require('owlcarousel/owl-carousel/owl.carousel.js');
require('owlcarousel/owl-carousel/owl.carousel.css');
require('owlcarousel/owl-carousel/owl.transitions.css');
require('jquery.scrollbar');

function initCategory() {

	if( $('#subcategories_slider').length ){

		//var intro_effects = ['ProductIntroslideInUp', 'ProductIntroslideInRight', 'ProductIntroslideInLeft'];
		var intro_slider = $('#subcategories_slider');
		intro_slider.owlCarousel({
			autoPlay : 3000,
			rewindNav : false,
		    navigation : false,
		    pagination : false,
		    singleItem : true,
		    transitionStyle : "fade",
		    addClassActive: true,
		    mouseDrag : false,
		    touchDrag: false,
		    lazyLoad: false,
		    autoHeight: false,
		    loop: true,
		    afterInit: function() {
		    	$('.owl-item img').addClass('lazypreload');
		    },
		    afterAction: function( slider ){

		    }
		});

	}	

	if( ('#product_filters').length ) {

		var focale_label = [];
		var categorie_label = [];
		var type_label = [];
		var option_label = [];
		var brand_label = [];

		var active_filters = ['.product_item'];

		addToFilters = function( filter ) {
			
			if( active_filters.indexOf(filter) < 0 ){
				active_filters.push(filter);
			}else{
				var index = active_filters.indexOf(filter);
				active_filters.splice(index, 1);
			}	

			if( active_filters.length > 1 )
				$('.product_item_list').addClass('with_filters');
			else
				$('.product_item_list').removeClass('with_filters');

			var filter_class = active_filters.join('.');
			$('.product_item').removeClass('active');
			$(filter_class).addClass('active');			

		}

		$('.product_item').each(function(index, item) {
			
			var focale = $(item).data('focale');
			if( focale && focale_label.indexOf(focale.class_value) < 0 ){
				focale_label.push(focale.class_value);
				$('#filter-focale ul').append('<li><a href="#" data-filter="'+ focale.class_value +'">'+ focale.value +'</a></li>');
			}

			var categorie = $(item).data('categorie');
			if( categorie && categorie_label.indexOf(categorie.class_value) < 0 ){
				categorie_label.push(categorie.class_value);
				$('#filter-category ul').append('<li><a href="#" data-filter="'+ categorie.class_value +'">'+ categorie.value +'</a></li>');
			}


			var type_a = $(item).data('type');
			if( type_a ){

				$.each(type_a, function(index, type ) {
					if( type_label.indexOf(type.class_value) < 0 ){
						type_label.push(type.class_value);
						$('#filter-type ul').append('<li><a href="#" data-filter="'+ type.class_value +'">'+ type.value +'</a></li>');				
					}
				});
			}	

			var option_a = $(item).data('options');
			if( option_a ){

				$.each(option_a, function(index, option ) {
					if( option_label.indexOf(option.class_value) < 0 ){
						option_label.push(option.class_value);
						$('#filter-options ul').append('<li><a href="#" data-filter="'+ option.class_value +'">'+ option.value +'</a></li>');				
					}
				});
			}

			var brand_a = $(item).data('brands');
			if( brand_a ){

				$.each(brand_a, function(index, brand ) {
					if( brand_label.indexOf(brand.class_value) < 0 ){
						brand_label.push(brand.class_value);
						$('#filter-brand ul').append('<li><a href="#" data-filter="'+ brand.class_value +'">'+ brand.value +'</a></li>');				
					}
				});
			}

		});

		$('#product_filters').on('click', 'a', function(e){
			e.preventDefault();
			$(this).toggleClass('active');

			addToFilters( $(this).data('filter') );
		});

		$('.product_filter_scrollable').scrollbar();

	}


}

module.exports = initCategory;


// WEBPACK FOOTER //
// ./js/category.js